let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("37ZO9"), load("1GxVg"), load("fZyYv")]).then(() => parcelRequire('7PP2u'));